import { buildDeviceInfo, DeviceType } from "@onmo/eon-streaming";
import {
  DeviceInfoInput,
  DeviceType as BackendDeviceType,
} from "@onmo/graphql/graphql";
import { isAndroidAppTv, isNativeApp, isTizen, isWebos } from "./platform";

/**
 * Detect the current device type based on platform and user agent.
 */
export function getDeviceType(): DeviceType {
  if (isAndroidAppTv) return "AndroidTV";
  if (isTizen) return "SamsungTV";
  if (isWebos) return "LGTV";

  const ua = navigator.userAgent;
  const isIpadOS = /macintosh/i.test(ua) && navigator.maxTouchPoints > 1;

  if (/tablet|ipad|playbook|silk/i.test(ua) || isIpadOS) return "Tablet";
  if (/mobile/i.test(ua)) return "Mobile";

  return "Desktop";
}

export function getBackendDeviceType(): BackendDeviceType {
  const type = getDeviceType();
  if (type === "AndroidTV" || type === "SamsungTV" || type === "LGTV") {
    return BackendDeviceType.Tv;
  }
  switch (type) {
    case "Mobile":
      return isNativeApp
        ? BackendDeviceType.MobileNative
        : BackendDeviceType.MobileWeb;
    case "Tablet":
      return isNativeApp
        ? BackendDeviceType.TabletNative
        : BackendDeviceType.TabletWeb;
    case "Desktop":
      return isNativeApp
        ? BackendDeviceType.DesktopNative
        : BackendDeviceType.DesktopWeb;
    default:
      return BackendDeviceType.Unknown;
  }
}

export function getDeviceInfo(): DeviceInfoInput {
  return buildDeviceInfo(getBackendDeviceType());
}
